// extracted by mini-css-extract-plugin
module.exports = {"form":"PinChange__form--3OK","formActions":"PinChange__formActions--1rT","title":"PinChange__title--10q","submit":"PinChange__submit--gyc"};